export const gemVersions = [
    "1.0",
    "2.0",
    "3.0 (1.0 에서 젬 단위 50배)",
    "4.0 (2.0 에서 젬 단위 50배)",
    "5.0",
]